import { message } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeTopNotification } from 'state/ducks/notifications/actions';
import { RootState } from 'state/utils/createStore';
import 'antd/lib/message/style/css';

interface Props {
  children?: React.ReactNode;
}

function NotificationProvider(props: Props) {
  const { children } = props;
  const messages = useSelector((state: RootState) => state.notifications.messages);
  const dispatch = useDispatch();

  useEffect(() => {
    if (messages.length > 0) {
      if (messages[0].element) {
        const node = document.getElementById(messages[0].element.elementIdentifier);

        if (node && typeof messages[0].element.func === 'function') {
          messages[0].element.func(messages[0]);
          // debugger; //eslint-disable-line
          // node.setAttribute("error", "true")
        } else {
          if (messages[0].type === 'Failure') {
            message.error(messages[0].message);
          } else {
            message.success({
              content: messages[0].message,
              icon: <span>{`✅ \u00a0`}</span>,
            });
          }
        }
      } else {
        if (messages[0].type === 'Failure') {
          message.error(messages[0].message);
        } else {
          message.success({
            content: messages[0].message,
            icon: <span>{`✅ \u00a0`}</span>,
          });
        }
      }
      dispatch(removeTopNotification());
    }
  }, [messages, dispatch]);

  return <>{children}</>;
}

export default NotificationProvider;
